var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCentralSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0C14.6966 0 9.60915 2.10711 5.85702 5.85698C2.10703 9.60893 0 14.696 0 19.9999C0 25.3037 2.10713 30.3907 5.85702 34.1428C9.60899 37.8927 14.6961 39.9997 20 39.9997C25.3039 39.9997 30.3909 37.8926 34.143 34.1428C37.893 30.3908 40 25.3037 40 19.9999C40 14.696 37.8929 9.60908 34.143 5.85698C30.391 2.10701 25.3039 0 20 0ZM20 31.1109C17.0536 31.1109 14.2263 29.9403 12.1427 27.857C10.0592 25.7737 8.88878 22.9463 8.88878 19.9998C8.88878 17.0533 10.0594 14.2261 12.1427 12.1425C14.226 10.059 17.0535 8.88863 20 8.88863C22.9465 8.88863 25.7737 10.0593 27.8573 12.1425C29.9408 14.2258 31.1112 17.0533 31.1112 19.9998C31.1112 22.9463 29.9406 25.7734 27.8573 27.857C25.774 29.9405 22.9465 31.1109 20 31.1109Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4427 20.0042C24.4427 22.4586 22.4526 24.4486 19.9982 24.4486C17.5439 24.4486 15.5538 22.4586 15.5538 20.0042C15.5538 17.5499 17.5439 15.5598 19.9982 15.5598C22.4526 15.5598 24.4427 17.5499 24.4427 20.0042Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCentralSelected);
export default __webpack_public_path__ + "static/media/central-selected.8ff591f5f62838c2bbba4fd286e1d9e8.svg";
export { ForwardRef as ReactComponent };